import Accordion from "../components/Accordion";
import Lotaip2 from "./Lotaip2";

import doc1 from "../docs/lotaip/2022/Literal_a1-Organigrama_de_la_institucion.pdf";
import doc2 from "../docs/lotaip/2022/Literal_a2-Base_legal_que_rige_a_la_institucion.pdf";
import doc3 from "../docs/lotaip/2022/Literal_a3-Regulaciones_y_procedimientos_internos.pdf";
import doc4 from "../docs/lotaip/2022/Literal_a4-Metas_y_objetivos_unidades_administrativas.pdf";
import doc5 from "../docs/lotaip/2022/Literal_b1-Directorio_de_la_institucion.pdf";
import doc6 from "../docs/lotaip/2022/Literal_c-Remuneracion_mensual_por_puesto.pdf";
import doc7 from "../docs/lotaip/2022/Literal_a3-Regulaciones_y_procedimientos_internos.pdf";
import doc8 from "../docs/lotaip/2022/literald.pdf";
import doc9 from "../docs/lotaip/2022/Literal_e-Texto_integro_de_contratos_colectivos_vigentes.pdf";
import doc10 from "../docs/lotaip/2022/Literal_g-Presupuesto_de_la_institucion.pdf";
import doc11 from "../docs/lotaip/2022/Literal_k-Planes_y_programas_en_ejecucion.pdf";
import doc12 from "../docs/lotaip/2022/literalm.pdf";
import doc13 from "../docs/lotaip/2022/Literal_o-Responsable_de_atender_la_informacion_publica_0.pdf";
import doc14 from "../docs/lotaip/2022/CERTIFICADO_LOTAIP_2022.pdf";

import docu1 from "../docs/lotaip/2021/a1.pdf";
import docu2 from "../docs/lotaip/2021/a2.pdf";
import docu3 from "../docs/lotaip/2021/a3.pdf";
import docu4 from "../docs/lotaip/2021/a4.pdf";
import docu5 from "../docs/lotaip/2021/b1.pdf";
import docu6 from "../docs/lotaip/2021/b2.pdf";
import docu7 from "../docs/lotaip/2021/c.pdf";
import docu8 from "../docs/lotaip/2021/certificado.pdf";
import docu9 from "../docs/lotaip/2021/e.pdf";
import docu10 from "../docs/lotaip/2021/g.pdf";
import docu11 from "../docs/lotaip/2021/k.pdf";
import docu12 from "../docs/lotaip/2021/m.pdf";
import docu13 from "../docs/lotaip/2021/o.pdf";
import docu14 from "../docs/lotaip/2021/certificado.pdf";





function Lotaip() {
  return (
    <>


<Lotaip2></Lotaip2>
      <Accordion
        title="LOTAIP 2022"
        content={
          <>
            <p>
              <a href={doc1}>a1) Organigrama de la Institución</a>
            </p>

            <p>
              <a href={doc2}>a2) Base legal que rige a la institución</a>
            </p>

            <p>
              <a href={doc3}>a3) Regulaciones y procedimientos internos</a>
            </p>

            <p>
              <a href={doc4}>a4) Metas y objetivos unidades administrativas</a>
            </p>

            <p>
              <a href={doc5}>b1) Directorio de la institución</a>
            </p>

            <p>
              <a href={doc6}>b2) Distributivo del personal</a>
            </p>

            <p>
              <a href={doc7}>c) Remuneración mensual por puesto</a>
            </p>

            <p>
              <a href={doc8}>
                d) Servicios que ofrece y la forma de acceder a ellos
              </a>
            </p>

            <p>
              <a href={doc9}>
                e) Texto íntegro de contratos colectivos vigentes
              </a>
            </p>

            <p>
              <a href={doc10}>g) Presupuesto de la Institución</a>
            </p>

            <p>
              <a href={doc11}>k) Planes y programas en ejecución</a>
            </p>

            <p>
              <a href={doc12}>
                m) Mecanismos de rendición de cuentas a la ciudadanía
              </a>
            </p>

            <p>
              <a href={doc13}>
                o) Responsable de atender la información pública
              </a>
            </p>

            <p>
              <a href={doc14}>CERTIFICADO LOTAIP 2022</a>
            </p>
          </>
        }
      ></Accordion>

      <Accordion
        title="LOTAIP 2021"
        content={
          <>
            <p>
              <a href={docu1}>a1) Organigrama de la Institución</a>
            </p>

            <p>
              <a href={docu2}>a2) Base legal que rige a la institución</a>
            </p>

            <p>
              <a href={docu3}>a3) Regulaciones y procedimientos internos</a>
            </p>

            <p>
              <a href={docu4}>a4) Metas y objetivos unidades administrativas</a>
            </p>

            <p>
              <a href={docu5}>b1) Directorio de la institución</a>
            </p>

            <p>
              <a href={docu6}>b2) Distributivo del personal</a>
            </p>

            <p>
              <a href={docu7}>c) Remuneración mensual por puesto</a>
            </p>

            <p>
              <a href={docu8}>
                d) Servicios que ofrece y la forma de acceder a ellos
              </a>
            </p>

            <p>
              <a href={docu9}>
                e) Texto íntegro de contratos colectivos vigentes
              </a>
            </p>

            <p>
              <a href={docu10}>g) Presupuesto de la institución</a>
            </p>

            <p>
              <a href={docu11}>k) Planes y programas en ejecución</a>
            </p>

            <p>
              <a href={docu12}>
                m) Mecanismos de rendición de cuentas a la ciudadanía
              </a>
            </p>

            <p>
              <a href={docu13}>
                o) Responsable de atender la información pública
              </a>
            </p>

            <p>
              <a href={docu14}>CERTIFICADO LOTAIP 2021</a>
            </p>
          </>
        }
      ></Accordion>
    </>
  );
}

export default Lotaip;
